import checkComposition from "./check-composition";
import getCurrentAndPrevious from "./get-current-and-previous";
import getValueOutput from "./get-value-output";

/**
 * Compute simple values (`tx(2rem)`)
 * @param {Number} progress
 * @param {PropertyValueProps} item
 * @param {String} initial
 * @param {Array<String | Array<String>>} array
 * @param {Number | null} index
 * @param {Boolean} isSafariInitial
 */
const computeSimpleValue = (
  progress,
  item,
  initial,
  array,
  index,
  isSafariInitial = false
) => {
  const isCalc = item.get("v_is-calc");
  const isInherit = item.get("v_is-inherit");

  const checked = checkComposition(item, isCalc);
  const isComposition = checked.get("is-composition");
  const result = getValueOutput(item, null, isCalc);

  if (!initial) {
    initial = `(0 * ${result})`;
  }

  if (isSafariInitial && item.get("v_unit")) {
    initial = `(0 * ${result})`;
  }

  if (isInherit) {
    return `0 * ${initial}`;
  }

  if (isComposition) {
    const composition = checked.get("composition");

    return `((-1) * (${composition}1) * (${progress} * ${result}))`;
  } else {
    return getCurrentAndPrevious(item, array, progress, initial, result, index);
  }
};

export default computeSimpleValue;
